import { Component, OnInit, Input } from '@angular/core';
import { LoadingStateService } from "../../services/loading-state-service";

@Component({
    selector: 'loading-spinner',
    templateUrl: './loading-spinner.component.html',
    styleUrls: ['./loading-spinner.component.scss'],
})
export class LoadingSpinnerComponent {
    @Input()
    public hideAutomatically: boolean = true;

    public constructor(public loadingService: LoadingStateService) {}
}



// WEBPACK FOOTER //
// ./src/viega-common/components/loading-spinner/loading-spinner.component.ts